module.exports = global["Handlebars"] = require("-!/biblio-ui-core/node_modules/handlebars/dist/handlebars.js");


//////////////////
// WEBPACK FOOTER
// ./~/handlebars/dist/handlebars.js
// module id = 2451
// module chunks = 0